export default class MissingPermissionException extends Error {
  constructor(...args) {
    super(...args);
    this.message = 'user is missing required permission(s).';
  }
}
